import { LoggerInterface } from "@interfaces/LoggerInterface";
import { WidgetInterface } from "@interfaces/WidgetInterface";

import InstagramGalleryServiceMainProductPageAdapter from "./adapters/InstagramGalleryServiceMainProductPageAdapter";
import InstagramPostsServiceMainOrInstagramPageAdapter from "./adapters/InstagramPostsServiceMainOrInstagramPageAdapter";
import { MAIN_PAGE_WIDGET } from "./constants";
import InstagramGalleryWidget from "./InstagramGalleryWidget";
import { InstagramGalleryWidgetConfigInterface } from "./InstagramGalleryWidgetConfig";

class InstagramGalleryMainPageWidget
    extends InstagramGalleryWidget
    implements WidgetInterface
{
    galleryServiceAdapter: InstagramGalleryServiceMainProductPageAdapter;
    postsServiceAdapter: InstagramPostsServiceMainOrInstagramPageAdapter;
    constructor(
        config: InstagramGalleryWidgetConfigInterface,
        logger: LoggerInterface
    ) {
        super(config, logger, MAIN_PAGE_WIDGET);
        if (!config.galleryId) {
            throw new Error();
        }
        this.galleryServiceAdapter =
            new InstagramGalleryServiceMainProductPageAdapter(
                this.galleryService,
                config.galleryId
            );
        this.postsServiceAdapter =
            new InstagramPostsServiceMainOrInstagramPageAdapter(
                this.postsService
            );
    }
}

export default InstagramGalleryMainPageWidget;
